function splitEarnKeySegments(earnKey: string): Array<string> {
  return earnKey.split(',').map((segment) => segment.trim()).filter(Boolean)
}

function composeEarnKey(
  base: string | undefined,
  markers: ReadonlyArray<string> | undefined,
): string | undefined {
  const segments = splitEarnKeySegments(base?.trim() ?? '')
  const seen = new Set(segments)

  for (const marker of markers ?? []) {
    const trimmedMarker = marker.trim()
    if (!trimmedMarker || seen.has(trimmedMarker)) continue

    segments.push(trimmedMarker)
    seen.add(trimmedMarker)
  }

  return segments.length > 0 ? segments.join(',') : undefined
}

export default composeEarnKey
